import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Box } = designSystem;

const BlockSettingsOptionBox = ({ children, marginBottom = '' }) => (
  <Box paddingLeft="spacing-m" paddingRight="spacing-m" {...(marginBottom && { marginBottom })}>
    {children}
  </Box>
);

BlockSettingsOptionBox.propTypes = {
  children: PropTypes.node.isRequired,
  marginBottom: PropTypes.string,
};

export default BlockSettingsOptionBox;
